import { twMerge } from "tailwind-merge"

interface TableAction {
    classProps?: string
    icon: React.ReactElement
    [key: string]: any
}

const TableAction: React.FC<TableAction> = ({ classProps, icon, ...props }) => {
  const tableActionStyle = twMerge('cursor-pointer', classProps)  
  return (
    <button className={tableActionStyle} {...props}>
        {icon}
    </button>
  )
}

export default TableAction